import React from 'react';
import styles from './MultiCardSelect.scss';
import Select from 'react-select';
import classnames from 'classnames';
import lodash from 'lodash';

export const MultiCardSelect = (props) => {
    const [options, setOptions] = React.useState([]);

    const placeholder = React.useMemo(() => {
        const count = lodash.get(props, 'value', []).length;
        return count === 0 ? props.placeholder : `${count} selected`;
    }, [props]);

    React.useEffect(() => {
        const selectedValueSet = new Set(lodash.map(props.value, 'value'));
        const remainingSelectedOptions = lodash.filter(props.options, ({ value }) => !selectedValueSet.has(value));

        setOptions(remainingSelectedOptions);
    }, [props.value, props.options, setOptions]);

    return (
        <React.Fragment data-cy="MultiCardSelect">
            <Select
                {...props}
                className={classnames(styles.Container, props.className)}
                options={options}
                value=""
                placeholder={placeholder}
                data-cy="MultiCardSelect-Select"
            />
            <SelectedCardItems selectedValues={props.value} handleRemove={props.onRemove} />
        </React.Fragment>
    );
};

export const SelectedCardItems = ({ selectedValues, handleRemove }) => {
    if (lodash.isEmpty(selectedValues)) return null;

    return (
        <ul className={styles.CardItemList} data-cy="MultiCardSelect-ul">
            {selectedValues.map((item) => (
                <li key={item.value} className={styles.CardItem} data-cy={`MultiCardSelect-li-${item.label}`}>
                    <p className={styles.CardItemText} data-cy={`MultiCardSelect-label-${item.label}`}>
                        {item.label}
                    </p>
                    <i
                        className={styles.CloseIcon}
                        onClick={() => handleRemove(item)}
                        data-cy={`MultiCardSelect-onClick-${item.value}`}
                    >
                        close
                    </i>
                </li>
            ))}
        </ul>
    );
};

export default MultiCardSelect;
